import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NearMissService } from 'src/app/services/near-miss.service';

@Component({
  selector: 'app-qr-scan-dialog',
  templateUrl: './qr-scan-dialog.component.html',
  styleUrls: ['./qr-scan-dialog.component.scss']
})
export class QrScanDialogComponent implements OnInit {
  locations: any[] = [];
  selectedLocation: string = '';
  loading: boolean = false;
  
  constructor(
    public dialogRef: MatDialogRef<QrScanDialogComponent>,
    private nearMissService: NearMissService
  ) { }

  ngOnInit(): void {
    // Load locations from API
    this.loadLocations();
  }

  loadLocations(): void {
    this.loading = true;
    
    const userJson = localStorage.getItem('currentUser') || localStorage.getItem('user') || '{}';
    const userData = JSON.parse(userJson);
    
    const request = {
      uid: userData.id || userData.uid || '',
      guid: userData.guid || '',
      active: 1,
      client_id: userData.client_id || '1'
    };

    this.nearMissService.getLocations(request).subscribe({
      next: (response) => {
        console.log('Locations loaded:', response);
        
        if (response && Array.isArray(response) && response.length > 0) {
          // Map API response to location objects with store_name and store_id
          this.locations = response.map((loc: any) => ({
            id: loc.id || loc.store_id,
            name: loc.store_name,
            store_id: loc.store_id,
            store_name: loc.store_name
          })).filter((loc: any) => loc.name); // Filter out any without names
          
          console.log('Mapped locations:', this.locations);
        } else {
          console.warn('No locations returned from API');
          this.locations = [];
        }
        
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading locations:', error);
        this.loading = false;
        // Set empty array on error
        this.locations = [];
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onOpenForm(): void {
    if (!this.selectedLocation) {
      return;
    }

    const selectedLoc = this.locations.find(loc => loc.name === this.selectedLocation);
    this.dialogRef.close({
      action: 'openForm',
      location: selectedLoc
    });
  }
}
